import { SelectOption } from '@infotrack/zenith-ui';

// Status options for SelectButton components
export const STATUS_OPTIONS: SelectOption<string>[] = [
  { value: 'Green', text: 'On Track' },
  { value: 'Orange', text: 'On Hold' },
  { value: 'Red', text: 'At Risk' },
];

// Result options for SelectButton components
export const RESULT_OPTIONS: SelectOption<string>[] = [
  { value: '', text: '' },
  { value: 'Pass', text: 'Pass' },
  { value: 'Fail', text: 'Fail' },
  { value: 'NA', text: 'NA' },
];

// Status value mappings for consistent handling
export const STATUS_VALUES = {
  GREEN: 'Green',
  ORANGE: 'Orange',
  RED: 'Red',
} as const;

export const RESULT_VALUES = {
  PASS: 'Pass',
  FAIL: 'Fail',
  NA: 'NA',
} as const;

// Status info mapping for consistent styling and display
export const STATUS_INFO_MAP = {
  // Results take priority
  [RESULT_VALUES.PASS]: {
    color: 'success/600',
    text: 'Pass',
    pillBgColor: 'success/100',
  },
  [RESULT_VALUES.FAIL]: {
    color: 'error/600',
    text: 'Fail',
    pillBgColor: 'error/200',
  },
  [RESULT_VALUES.NA]: {
    color: 'neutral/500',
    text: 'NA',
    pillBgColor: 'neutral/100',
  },
  // Status fallbacks
  [STATUS_VALUES.GREEN]: {
    color: 'information/600',
    text: 'On Track',
    pillBgColor: 'primary/100',
  },
  [STATUS_VALUES.ORANGE]: {
    color: 'alert/600',
    text: 'On Hold',
    pillBgColor: 'alert/100',
  },
  [STATUS_VALUES.RED]: {
    color: 'error/600',
    text: 'At Risk',
    pillBgColor: 'error/200',
  },
} as const;

// Default status info
export const DEFAULT_STATUS_INFO = {
  color: 'neutral/500',
  text: 'No Status',
  pillBgColor: 'neutral/100',
} as const;

// Re-export the utility function for convenience
export { getStatusInfo } from '../utils/statusUtils';
